var map = {
	"./BACKGROUND.png": 391,
	"./BUBBLE_FIELD_BACKGROUND.png": 392,
	"./bg_shadow.png": 393,
	"./shoutout_bg.png": 394,
	"./warning_pillar.png": 395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 390;